// © Microsoft Corporation. All rights reserved.

const DefaultSize1ColumnWidth = 300;
const DefaultSize2ColumnWidth = 624;
const DefaultSize3ColumnWidth = 948;
const DefaultSize4ColumnWidth = 1272;
const DefaultSize5ColumnWidth = 1596;
const DefaultGutterSize = 24;

export const Size1ColumnWidth = DefaultSize1ColumnWidth;
export let Size2ColumnWidth = DefaultSize2ColumnWidth;
export let Size3ColumnWidth = DefaultSize3ColumnWidth;
export let Size4ColumnWidth = DefaultSize4ColumnWidth;
export let Size5ColumnWidth = DefaultSize5ColumnWidth;
export let GutterSize = DefaultGutterSize;

/** Updates the current ColumnWidths based on changes in gutterSize */
export function updateColumnWidths(gutterSize: number): void {
    GutterSize = gutterSize;
    Size5ColumnWidth = (Size1ColumnWidth * 5) + (gutterSize * 4);
    Size4ColumnWidth = (Size1ColumnWidth * 4) + (gutterSize * 3);
    Size3ColumnWidth = (Size1ColumnWidth * 3) + (gutterSize * 2);
    Size2ColumnWidth = (Size1ColumnWidth * 2) + gutterSize;
}

/** Resets the ColumnWidths to their default values */
export function resetColumnWidthsAndGutterSize(): void {
    GutterSize = DefaultGutterSize;
    Size2ColumnWidth = DefaultSize2ColumnWidth;
    Size3ColumnWidth = DefaultSize3ColumnWidth;
    Size4ColumnWidth = DefaultSize4ColumnWidth;
    Size5ColumnWidth = DefaultSize5ColumnWidth;
}